import { useCallback, useState, useEffect } from 'react';

const getInitialExpandedSections = () => {
  const queryParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
  const hasEditParams = queryParams.has('editId') && queryParams.has('editType');
  return {
    csat: false,
    progress: false,
    efforts: false,
    projectUnits: false,
    reasonsRemarks: false,
    audit: false,
    risk: hasEditParams,
    milestone: false,
    resourceCount: false,
    resourceDetails: false,
    allocationDetails: false,
    tbhResources: false,
  };
};

const useExpandableSections = () => {
  const [expandedSections, setExpandedSections] = useState(getInitialExpandedSections);

  useEffect(() => {
    const queryParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
    const hasEditParams = queryParams.has('editId') && queryParams.has('editType');
    if (hasEditParams) {
      setExpandedSections((prev) => ({
        ...prev,
        risk: true,
      }));
    }
  }, []);

  const toggleSection = useCallback((section) => {
    setExpandedSections((prev) => {
      const next = { ...prev, [section]: !prev[section] };
      return next;
    });
  }, []);

  return { expandedSections, toggleSection };
};

export default useExpandableSections;
